module.exports = __webpack_public_path__ + "img/testimonials-banner.afa7d49e.jpg";